import { TbCrown, TbUsers } from 'react-icons/tb';

import { STATUS_LABEL } from '../subscription.constants';
import s from '../subscription.module.scss';
import type { SeatPool } from '../subscription.seats';
import type { PlanStatus } from '../subscription.types';

export const SeatPoolIcon = ({ pool }: { pool: SeatPool }) =>
  pool === 'management' ? <TbCrown /> : <TbUsers />;

export const StatusChip = ({ status }: { status: PlanStatus }) => (
  <span className={`${s.statusChip} ${s[`status_${status}`]}`}>{STATUS_LABEL[status]}</span>
);
